module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-wrap",
    class: [_vm.type]
  }, [_c('div', {
    staticClass: "step-header"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-item",
      class: {
        'is-active': _vm.currentIndex === index, 'is-done': index < _vm.currentIndex
      },
      style: ({
        stepStyle: _vm.stepStyle
      })
    }, [_c('div', {
      staticClass: "step-left"
    }, [_c('div', {
      staticClass: "step-icon"
    }, [(index >= _vm.currentIndex) ? _c('span', [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (index < _vm.currentIndex) ? _c('span', [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "step-desc"
    }, [_c('span', {
      staticClass: "step-title"
    }, [_vm._v(_vm._s(step.title))])]), _vm._v(" "), _c('div', {
      staticClass: "step-description"
    }, [_vm._v(_vm._s(step.description))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "step-content is-flex"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "step-footer has-text-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.prev
    }
  }, [_vm._v(_vm._s(_vm.prevText))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.nextText))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46b9613e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Steps.vue
// module id = 335
// module chunks = 0